/**
 * Strips common markdown formatting from a string, returning plain text.
 */
export function stripMarkdown(text: string): string {
  if (!text) return text;
  return (
    text
      // Bold/italic
      .replace(/\*\*\*(.*?)\*\*\*/g, "$1")
      .replace(/\*\*(.*?)\*\*/g, "$1")
      .replace(/\*(.*?)\*/g, "$1")
      // Strikethrough
      .replace(/~~(.*?)~~/g, "$1")
      // Underline
      .replace(/\+\+(.*?)\+\+/g, "$1")
      // Headers
      .replace(/^#{1,6}\s+/gm, "")
      // Unordered list markers (preserve indentation)
      .replace(/^(\s*)[-*+]\s+/gm, "$1")
      // Ordered list markers
      .replace(/^(\s*)\d+\.\s+/gm, "$1")
      // Blockquotes
      .replace(/^>\s?/gm, "")
      // Inline code
      .replace(/`([^`]+)`/g, "$1")
      // Horizontal rules
      .replace(/^---+$/gm, "")
      // Non-breaking spaces
      .replace(/&nbsp;/g, " ")
  );
}
